export default __webpack_public_path__ + "static/ahu_b.b7a5873b813957c0eac722083797e950.png";